<template>
<div>
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="50" >
            <v-toolbar-title style="color:#62AE32" class="headline">View Profile</v-toolbar-title>
        </v-toolbar>    

        <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
            <span>Successfully changed password..</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="passError" :timeout="4000" top color="red">
            <span>{{errMsg}}</span> 
            <v-btn text color="white" @click="passError = false">Close</v-btn>
        </v-snackbar>
       
        <v-row justify="center">
            <v-avatar size="120">
         <v-img class="" :src="getImgUrl(Images.profile_img_url)" alt="/profile_pic.svg" lazy-src="/profile_pic.svg"></v-img>
            </v-avatar>
        </v-row>
        <v-row justify="center" class="ml-12 mr-n12 mt-n6">
            <div class="ml-12 mr-n12 mb-6">
                <v-btn icon class="ml-10" to="/profile/editProfile">
                    <v-icon color="#08911b" >mdi-pencil</v-icon>
                </v-btn>
                
                <v-subheader style="color: grey" class="mt-n3 ml-7 title1">Edit Profile</v-subheader>  
            </div> 
        </v-row>        
        <div>
            <v-card class="mx-auto" color="#F0FFEA" max-width="400" flat> 
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Firstname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            readonly
                            solo
                            flat
                            dense
                            v-model="firstname"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                 <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Lastname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            readonly
                            solo
                            flat
                            dense
                            v-model="lastname"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="email"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Username</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="username"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Phone Number</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="contact"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>      
                 <v-layout class="my-4">
                <v-spacer></v-spacer>
                 <v-dialog persistent v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                <v-btn color="#08911b" :loading="loading" class="white--text btn-style" v-on:click="Update()" v-on="on">
                    Change Password</v-btn>
                </template>
                  <v-card>
                    <v-card-title>
                    <span class=" black--text">Change Password</span>
                    </v-card-title>

                    <v-card-text>
                    <v-form>
                        <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                              label="Old Password"
                              v-model="oldpassword"
                              color="#5F5D5D" 
                               :append-icon="show1 ? 'visibility' : 'visibility_off'"
                              :type="show1 ? 'text' : 'password'"
                              @click:append="show1 = !show1" 
                            ></v-text-field>
                    </v-col>
                </v-row>
                    <v-row>
                        <v-col
                        cols="12"
                         sm="12"
                            md="8">
                             <v-text-field
                              label="New Password"
                              v-model="newpassword" 
                              color="#5F5D5D" 
                               :append-icon="show2 ? 'visibility' : 'visibility_off'"
                              :type="show2 ? 'text' : 'password'"
                              @click:append="show2 = !show2" 
                            ></v-text-field>
                      
                        </v-col>
                    </v-row>
                </v-form>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#62AE32" text @click="save">CANCEL</v-btn>
                    <v-btn color="#62AE32" :loading="loading" text @click="change">Change</v-btn>
                    
                    </v-card-actions>
                </v-card>
                 </v-dialog>
                </v-layout>

            </v-card>
        </div>
    </div>
    <!-- reset password button -->
  
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'profile',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            dialog:false,
            snackbar: false,
            firstname:"",
            lastname: '',
            email:"",
            username:"",
            oldpassword: '',
            newpassword: '',
            show1: false,
            show2: false,
            contact:"",
            policyStatus:'',
            loading: false,
            passError:false,
            errMsg:false,
            // url:"http://192.168.1.112:3000"
            // url:"https://cover-my-car.herokuapp.com"
            url:"https://res.cloudinary.com/dmnghlyic/image/upload/v1587634815/"
        }),
        computed:{
            Images(){
                return this.$store.state.community.logindetails
             }
        },
        methods:{ 
            save(){
                this.dialog=false
            },
            change(){
                this.loading = true
                this.$store.dispatch("changePassword",{
                    "oldpassword": this.oldpassword,
                    "newpassword": this.newpassword,
                    "username": this.$store.state.community.logindetails.consultant_id 
                })
                .then((success)=>{
                    console.log(success);
                    this.loading = false
                    this.dialog=false
                    this.snackbar = true
                })
                .catch((error)=>{
                    if(error.response.status===400){
                        this.loading = false;
                        this.errMsg= error.response.data.message
                        this.passError = true;
                    }else{
                        this.loading = false
                    }
                })
            },
            getImgUrl(pic) {
                if(pic==="" || pic===null){
                    let image="/profile_pic.svg"
                    return image
                }else{
                    let weblink = this.url;
                    return weblink+pic;
                }
                
            },
        },
        created(){
            this.firstname = this.$store.state.community.logindetails.firstname 
            this.lastname = this.$store.state.community.logindetails.lastname
            this.email = this.$store.state.community.logindetails.email
            this.username = this.$store.state.community.logindetails.consultant_id 
            this.contact = this.$store.state.community.logindetails.phone_number
        }
    }
</script>